export default {"src":"/_next/static/image/assets/Illustrations/iconShare.4dd306b69915702899137821a09ef314.svg","height":16,"width":18};